<template>
  <layout-vertical>
    <div class="d-block d-sm-none">
      <!--          <transition name="fade">-->
      <!--              <main-menu-component />-->
      <!--          </transition>-->
      <bottom-menu-component />
    </div>
    <router-view />

    <!--    <template #navbar="{ toggleVerticalMenuActive }">-->
    <!--      <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />-->
    <!--    </template>-->

    <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    />
  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
import { $themeConfig } from '@themeConfig'
import BottomMenuComponent from '@/@core/components/BottomMenuComponent.vue'
// import TopMenuComponent from "@/@core/components/TopMenuComponent.vue";
import MainMenuComponent from '@/@core/components/MainMenuComponent.vue'

export default {
  components: {
    AppCustomizer,
    LayoutVertical,
    BottomMenuComponent,
    // TopMenuComponent,
    MainMenuComponent,
  },
  data() {
    return {
      showCustomizer: $themeConfig.layout.customizer,
    }
  },
  computed: {
    isMainMenuOpen() {
      return this.$store.state.app.isMainMenuOpen
    },
  },
}
</script>
